import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonSegment, IonSegmentButton, IonIcon } from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { ValidationUtil } from "@qid/core";
import { CryptoUtil } from "@qid/crypto";
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent } from '@qid/super';
import { firstValueFrom } from "rxjs";
import { UsersSelectors } from "../../../user";
import { EncryptionKeysService } from "../../services/encryption-keys.service";

@Component({
  selector: 'create-encryption-keys',
  templateUrl: './create-encryption-key.component.html',
  styleUrls: ['./create-encryption-key.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    IonSegment,
    IonSegmentButton,
    IonIcon
  ],
})
export class CreateEncryptionKeyComponent implements OnInit {

  @Input() entityId: string;

  slides = {
    passwordOptions: 'passwordOptions',
    setPassword: 'setPassword',
    confirmation: 'confirmation'
  }

  activeSlide = this.slides.passwordOptions

  inputPassword: string;
  inputConfirmPassword: string;

  setupRecoveryPin: boolean;

  public authenticatedUser$ = this.store.select(UsersSelectors.selectAuthenticatedUser)

  constructor(private encryptionService: EncryptionKeysService,
    private store: Store
  ) {
  }

  ngOnInit() {
  }

  goToSlide(slide: string) {
    this.activeSlide = slide
  }

  async autoGeneratePassword() {
    this.goToSlide(this.slides.confirmation)
    const res = await this.encryptionService.autoGenerate()
  }

  onPinConformed = async () => {

    this.validateInputPins()

    if (this.setupRecoveryPin == null) {
      throw "Please select whether you want a recovery PIN or not"
    }

  }

  async validateInputPins() {

    ValidationUtil.validate6DigitPin(this.inputPassword)

    if (this.inputPassword != this.inputConfirmPassword) {
      throw "PINs do not match"
    }

    await this.generateEncryptionKey();

  }

  generateEncryptionKey = async () => {

    const authenticatedUser = await firstValueFrom(this.authenticatedUser$)
    let recoveryKeyphrase = null
    if (this.setupRecoveryPin) {
      recoveryKeyphrase = CryptoUtil.generateSecureKeyphrase()
    }

    const key = await CryptoUtil.generateUserKeys(this.inputPassword, recoveryKeyphrase);

    await this.encryptionService.create({
      account_id: authenticatedUser?._id,
      key: key.key,
      publicKey: key.publicKey,
      salt: key.salt,
      iv: key.iv,
      recoveryKey: key.recoveryKey
    })

  }
}
